import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import Grid from '../grid';
import StaggerIn from '../stagger-in';

const gridStyles = `
  text-align: center;
  grid-gap: 0;

  ${screen.below(bp.mobile, `
    grid-template-columns: repeat(2, 1fr);
  `)};
`;

const StatGrid = ({ stats, isTumi }) => {
  if (stats.length < 1) return null;

  return (
    <StaggerIn>
      <Grid cols={isTumi ? 3 : 4} styles={gridStyles}>
        {stats.map((stat, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <ImpactGridItem className="js-stagger" span={1} key={i} isTumi={isTumi}>
            <ImpactHeading>{stat.value}</ImpactHeading>
            <span>{stat.title}</span>
          </ImpactGridItem>
        ))}
      </Grid>
    </StaggerIn>
  );
};

const ImpactHeading = styled.h4`
  color: ${props => props.theme.blue};
`;

const ImpactGridItem = styled(Grid.Item)`
  padding: 80px 0;

  span {
    font-size: ${rem(16)};
  }

  ${css`
    ${props => (screen.above(bp.mobile, `
      &:not(:first-of-type) {
        border-left: 1px solid ${props.theme.gray};
      }
    `))};
  `};

  ${css`
    ${props => (screen.below(bp.mobile, `
      padding: 36px 0;

      &:nth-of-type(even) {
        border-left: 1px solid ${props.theme.gray};
      }

      &:nth-of-type(-n+2) {
        border-bottom: 1px solid ${props.theme.gray};
      }

      ${props.isTumi && css`
        padding: 36px 15px;

        &:last-of-type {
          grid-column: 1 / -1;
        }
      `}
    `))};
  `};
`;

StatGrid.propTypes = {
  stats: PropTypes.array,
  isTumi: PropTypes.bool,
};

StatGrid.defaultProps = {
  stats: [],
};

export default StatGrid;
